<template>
    <div
      class="modal fade createNewModal"
      id="AddMagasinModal"
      tabindex="-1"
      ref="addMagasinModalRef"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-15 p-md-40">
          <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
            <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
          </div>
          <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
            <Form ref="magasinForm" @submit="addMagasin" :validation-schema="magasinSchema">
                
                <div class="row">

                  <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                      Libelle <span class="text-danger">*</span>
                      </label>
                      <Field name="libelle" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le libelle"/>
                      <ErrorMessage name="libelle" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                      Téléphone <span class="text-danger">*</span>
                      </label>
                      <Field name="telephone" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le telephone"/>
                      <ErrorMessage name="telephone" class="text-danger"/>
                  </div>
                  </div>

                </div>

                <div class="col-md-12">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      Adresse <span class="text-danger">*</span>
                    </label>
                    <Field name="adresse" as="textarea"  cols="30"
                      rows="12" placeholder="Entrer l'adresse" v-slot="{ field}" class="form-control shadow-none rounded-0 text-black">
                      <textarea
                        class="form-control shadow-none rounded-0 text-black"
                        v-model="field.value">
                      </textarea>
                    </Field>
                    <ErrorMessage name="adresse" class="text-danger"/>
                  </div>
                </div>
              
              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                type="submit">
                {{ btntext }}
              </button>
          </Form>
          </div>
          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="resetValue()"
          ></button>
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref, watch, onMounted } from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import ApiService from '../../services/ApiService';
  import * as Yup from 'yup';
  import { Magasin } from '../../models/Magasin';
  import { error , success, hideModal } from '../../utils/utils';
  
  export default defineComponent({
      name: "AddMagasinModal",
      components: {
      Form,
      Field,
      ErrorMessage
    },
    props: {
      item: {
        type: Number,
        default: 0,
      }
    },
    setup(props, { emit }){
      const magasinSchema = Yup.object().shape({
        libelle: Yup.string().required('Le libelle est obligatoire'),
        adresse: Yup.string().required('L\'adresse est obligatoire'),
        telephone: Yup.string().required('Le téléphone est obligatoire'),
      });
  
      
      const magasinForm = ref<Magasin | null>(null);
      const addMagasinModalRef = ref<null | HTMLElement>(null);
      
      
      const isUPDATE = ref(false);
      const title = ref("Ajouter un magasin");
      const btntext = ref('Enregistrer');
  
      watch(() => props.item, (newValue) => {
        getMagasin(newValue);
        isUPDATE.value = true;
        btnTitle();
      });
  
      const btnTitle = async () => {
        if (isUPDATE.value) {
           title.value = "Modifier le magasin";
           btntext.value = "Modifier";
        }else{
           title.value = "Ajouter un magasin";
           btntext.value = "Enregistrer";
        }
      }
  
      const defaultSelectedCategories = ref<any[]>([]);
      const produitsError = ref(false); 
  
      watch(defaultSelectedCategories, () => {
        console.log('name', defaultSelectedCategories.value)
        if(defaultSelectedCategories.value.length > 0){
          produitsError.value = false
        }
        else {
          produitsError.value = true
        }
      })
      const getMagasin = async (id: number) => {
        return ApiService.get("/magasin/"+id)
        .then(({ data }) => {
          // map data in form
          const donnees = data.data;
          // const categories = donnees.categories;
  
          // let ids: number[] = [];
          // for (const categorie of categories) {
          //   ids.push(categorie.id); 
          // }
          // categories.value= ids;
  
          // defaultSelectedCategories.value = categories.value
          for (const key in donnees) {
            magasinForm.value?.setFieldValue(key, 
            (typeof donnees[key] === 'object' && donnees[key] !== null)? donnees[key].id :donnees[key]
            );
          }
          emit('openmodal', addMagasinModalRef.value);
  
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
      }
  
      const addMagasin = async (values: any, magasinForm) => {
        
        values = values as Magasin;
        if(isUPDATE.value){
          ApiService.put("/magasin/"+values.id,values)
          .then(({ data }) => {
              if(data.code == 200) { 
                success(data.message);
                magasinForm.resetForm();
                hideModal(addMagasinModalRef.value);
                isUPDATE.value=false;
                btnTitle();
                emit('close');
              }
          })
          .catch(({ response }) => {
              error(response.data.message);
          });
        }else{
          console.log("je suis la",isUPDATE.value);
          
          ApiService.post("/magasin",values)
          .then(({ data }) => {
              if(data.code == 201) { 
                success(data.message);
                magasinForm.resetForm();
                hideModal(addMagasinModalRef.value);
                emit('close');
              }
          })
          .catch(({ response }) => {
              error(response.data.message);
          });
        }
      };
     
  
      // onMounted(() => {
        
      // });
  
      const resetValue = () => {
        const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
          isUPDATE.value=false;
        formFields.forEach(field => {
          field.value = '';
        });
        btnTitle()
      };
  
      return { 
        magasinSchema,
        addMagasinModalRef,
        addMagasin,
        magasinForm,
        title,btntext,
        resetValue,
        defaultSelectedCategories,
        produitsError,
      };
    },
  });
  </script>